var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"btn down",on:{"click":function($event){return _vm.toDownload()}}},[_vm._v("异常修复")]),_c('img',{staticClass:"bg",attrs:{"src":require("@/assets/img/bg.png"),"alt":"bg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }